module.exports = __webpack_public_path__ + "img/square.f3d2cffc.svg";